// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./background-colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Chatbot.css */
.chatbot-container {
  width: 355px;
  position: fixed;
  bottom: 5px;
  right: 10px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}


.custom-primary {
  background-color: beige;
  /* Replace with your custom color */
  color: white;
  /* Ensure the text is readable */
}

.card-header.card-bot {
  padding: 10px;
}

.chatbot-messages {
  height: 365px;
  overflow-y: auto;
}

.message {
  margin-bottom: 10px;
}

.message.user .message-text {
  margin-left: auto;
  max-width: 90%;
  border-radius: 5px 5px 5px 0;
  padding: 12px;
  font-size: 14px;
  /* font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif, Helvetica, sans-serif */
}

.message.bot .message-text {
  max-width: 100%;
  border-radius: 5px 5px 5px 0;
  padding: 12px;
  font-size: 14px;
  /* font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif, Helvetica, sans-serif */
}

.btn.btn-bot {
  padding: 0 5px;
  font-size: 12px;
}

.chatbot-container.minimized {
  position: fixed;
  bottom: 6px;
  right: 6px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
}

.chat-icon {
  width: 70%;
  height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease-in-out;
  /* Smooth transition */
}

.chat-icon-image {
  max-width: 100%;
  max-height: 100%;
  width: 45px;
  /* Same size as FaComments */
  height: 45px;
  /* Adjust as needed */
  object-fit: contain;
  /* Ensures the image scales nicely */
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  50% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-5px);
  }

  100% {
    transform: translateX(0);
  }
}

.chat-icon-image {
  animation: shake 0.5s ease-in-out infinite;
  animation-delay: 5s;
}

.chat-widget {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-align: center;
}

.chat-bubble {
  background-color: #6c757d; /* Gray background */
  color: white;
  padding: 8px 16px; /* Padding inside the bubble */
  border-radius: 20px; /* Rounded corners for the bubble */
  font-size: 14px;
  font-weight: bold;
  position: fixed; /* Makes the bubble fixed relative to the viewport */
  top: 449px; /* Distance from the top of the viewport */
  left: 50%; /* Centers horizontally */
  transform: translateX(-50%); /* Adjusts for true centering */
  z-index: 1000; /* Ensures the bubble appears above other elements */
  text-align: center; /* Centers the text */
}


.chat-bubble::after {
  content: "";
  position: absolute;
  bottom: -10px;
  /* Position the arrow */
  left: 50%;
  transform: translateX(-50%);
  border-width: 10px;
  border-style: solid;
  border-color: #6c757d transparent transparent transparent;
}

/* .message-text {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 10px; Adjust as needed
} */

.timestamp {
  font-size: 0.75rem;
  /* Smaller font size for timestamp */
  color: #6c757d;
  /* Bootstrap text-muted color or your choice */
  margin-top: 2px;
  /* Space between message and timestamp */
  text-align: right;
  /* Aligns the timestamp to the right */
}`, "",{"version":3,"sources":["webpack://./src/assets/css/Chatbot.css"],"names":[],"mappings":"AAAA,+BAA+B;AAG/B;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;AACf;;;AAGA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,kGAAkG;AACpG;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,kGAAkG;AACpG;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;EACZ,iBAAiB,EAAE,8BAA8B;EACjD,mBAAmB,EAAE,mCAAmC;EACxD,eAAe;EACf,iBAAiB;EACjB,eAAe,EAAE,oDAAoD;EACrE,UAAU,EAAE,0CAA0C;EACtD,SAAS,EAAE,yBAAyB;EACpC,2BAA2B,EAAE,+BAA+B;EAC5D,aAAa,EAAE,oDAAoD;EACnE,kBAAkB,EAAE,qBAAqB;AAC3C;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;;;;;GAKG;;AAEH;EACE,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,8CAA8C;EAC9C,eAAe;EACf,wCAAwC;EACxC,iBAAiB;EACjB,sCAAsC;AACxC","sourcesContent":["/* src/components/Chatbot.css */\r\n\r\n@import './background-colors.css';\r\n.chatbot-container {\r\n  width: 355px;\r\n  position: fixed;\r\n  bottom: 5px;\r\n  right: 10px;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  z-index: 1000;\r\n}\r\n\r\n\r\n.custom-primary {\r\n  background-color: beige;\r\n  /* Replace with your custom color */\r\n  color: white;\r\n  /* Ensure the text is readable */\r\n}\r\n\r\n.card-header.card-bot {\r\n  padding: 10px;\r\n}\r\n\r\n.chatbot-messages {\r\n  height: 365px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.message {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.message.user .message-text {\r\n  margin-left: auto;\r\n  max-width: 90%;\r\n  border-radius: 5px 5px 5px 0;\r\n  padding: 12px;\r\n  font-size: 14px;\r\n  /* font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif, Helvetica, sans-serif */\r\n}\r\n\r\n.message.bot .message-text {\r\n  max-width: 100%;\r\n  border-radius: 5px 5px 5px 0;\r\n  padding: 12px;\r\n  font-size: 14px;\r\n  /* font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif, Helvetica, sans-serif */\r\n}\r\n\r\n.btn.btn-bot {\r\n  padding: 0 5px;\r\n  font-size: 12px;\r\n}\r\n\r\n.chatbot-container.minimized {\r\n  position: fixed;\r\n  bottom: 6px;\r\n  right: 6px;\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 50%;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  background-color: transparent;\r\n}\r\n\r\n.chat-icon {\r\n  width: 70%;\r\n  height: 70%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: transform 0.2s ease-in-out;\r\n  /* Smooth transition */\r\n}\r\n\r\n.chat-icon-image {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  width: 45px;\r\n  /* Same size as FaComments */\r\n  height: 45px;\r\n  /* Adjust as needed */\r\n  object-fit: contain;\r\n  /* Ensures the image scales nicely */\r\n}\r\n\r\n@keyframes shake {\r\n  0% {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  25% {\r\n    transform: translateX(-5px);\r\n  }\r\n\r\n  50% {\r\n    transform: translateX(5px);\r\n  }\r\n\r\n  75% {\r\n    transform: translateX(-5px);\r\n  }\r\n\r\n  100% {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.chat-icon-image {\r\n  animation: shake 0.5s ease-in-out infinite;\r\n  animation-delay: 5s;\r\n}\r\n\r\n.chat-widget {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  text-align: center;\r\n}\r\n\r\n.chat-bubble {\r\n  background-color: #6c757d; /* Gray background */\r\n  color: white;\r\n  padding: 8px 16px; /* Padding inside the bubble */\r\n  border-radius: 20px; /* Rounded corners for the bubble */\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  position: fixed; /* Makes the bubble fixed relative to the viewport */\r\n  top: 449px; /* Distance from the top of the viewport */\r\n  left: 50%; /* Centers horizontally */\r\n  transform: translateX(-50%); /* Adjusts for true centering */\r\n  z-index: 1000; /* Ensures the bubble appears above other elements */\r\n  text-align: center; /* Centers the text */\r\n}\r\n\r\n\r\n.chat-bubble::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: -10px;\r\n  /* Position the arrow */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  border-width: 10px;\r\n  border-style: solid;\r\n  border-color: #6c757d transparent transparent transparent;\r\n}\r\n\r\n/* .message-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  padding: 10px; Adjust as needed\r\n} */\r\n\r\n.timestamp {\r\n  font-size: 0.75rem;\r\n  /* Smaller font size for timestamp */\r\n  color: #6c757d;\r\n  /* Bootstrap text-muted color or your choice */\r\n  margin-top: 2px;\r\n  /* Space between message and timestamp */\r\n  text-align: right;\r\n  /* Aligns the timestamp to the right */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
